if (!customElements.get('linkgroup-dropdown')) {
  customElements.define('linkgroup-dropdown', 
    class LinkgroupDropdown extends HTMLElement {
      constructor() {
        super();
        this.toggle = null;
        this.content = null;
        this.selectedText = null;
        this.links = null;
        this.outsideClickHandler = null;
        this.escapeKeyHandler = null;
      }
    
      connectedCallback() {
        this.init();
      }
    
      disconnectedCallback() {
        this.cleanup();
      }
    
      init() {
        this.toggle = this.querySelector('.linkgroup-dropdown__toggle');
        this.content = this.querySelector('.linkgroup-dropdown__content');
        this.selectedText = this.querySelector('.linkgroup-dropdown__selected');
        this.links = this.querySelectorAll('.linkgroup-dropdown__link');
    
        if (!this.toggle || !this.content || !this.selectedText) return;
    
        this.setupEventListeners();
      }
    
      setupEventListeners() {
        // Toggle dropdown
        this.toggle.addEventListener('click', this.handleToggleClick.bind(this));
    
        // Handle product selection
        this.links.forEach(link => {
          link.addEventListener('click', this.handleLinkClick.bind(this));
        });
    
        // Close dropdown when clicking outside
        this.outsideClickHandler = this.handleOutsideClick.bind(this);
        document.addEventListener('click', this.outsideClickHandler);
    
        // Close dropdown on escape key
        this.escapeKeyHandler = this.handleEscapeKey.bind(this);
        document.addEventListener('keydown', this.escapeKeyHandler);
      }
    
      handleToggleClick(e) {
        e.preventDefault();
        const isExpanded = this.toggle.getAttribute('aria-expanded') === 'true';
        
        this.toggle.setAttribute('aria-expanded', !isExpanded);
        this.content.setAttribute('aria-hidden', isExpanded);
      }
    
      handleLinkClick(e) {
        const productTitle = e.currentTarget.querySelector('.linkgroup-dropdown__product-title').textContent;
        
        // Remove active class from all links
        this.links.forEach(link => {
          link.classList.remove('linkgroup-dropdown__link--active');
        });
        
        // Add active class to clicked link
        e.currentTarget.classList.add('linkgroup-dropdown__link--active');
        
        // Update selected text
        this.selectedText.textContent = productTitle;
        this.selectedText.style.color = '#313131';
        
        // Close dropdown
        this.toggle.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('aria-hidden', 'true');
      }
    
      handleOutsideClick(e) {
        if (!this.contains(e.target)) {
          this.toggle.setAttribute('aria-expanded', 'false');
          this.content.setAttribute('aria-hidden', 'true');
        }
      }
    
      handleEscapeKey(e) {
        if (e.key === 'Escape' && this.toggle.getAttribute('aria-expanded') === 'true') {
          this.toggle.setAttribute('aria-expanded', 'false');
          this.content.setAttribute('aria-hidden', 'true');
          this.toggle.focus();
        }
      }
    
      cleanup() {
        if (this.outsideClickHandler) {
          document.removeEventListener('click', this.outsideClickHandler);
        }
        if (this.escapeKeyHandler) {
          document.removeEventListener('keydown', this.escapeKeyHandler);
        }
      }
    
      // Public method to reinitialize (useful after DOM updates)
      reinit() {
        this.cleanup();
        this.init();
      }
    }
  );
}